<template>
    <EditingDialog
        :context="context"
        :showSnackbar="true"
        snackbarTextLangConst="lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON"
        :useDifferentShowDialogProp="true"
        :additionalSaveFunction="formatDataBeforeSave"
        :useAdditionalSaveFunction="true"
        :additionalAfterSaveFunction="afterSaving"
    >
        <template v-slot:editForm>
            <v-row>
                <v-col>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Description"
                        :label="$t('lang_GENERIC_CAPTION_DESCRIPTION')"
                        :withMargin="false"
                        rules="required"
                        :alvqa="alvqa + '-textfield-description'"
                    />
                </v-col>
                <v-col>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Amount"
                        :label="$t('lang_GENERIC_CAPTION_AMOUNT')"
                        :withMargin="false"
                        rules="required|publishingBalanceNotGreaterThanZero"
                        :alvqa="alvqa + '-textfield-amount'"
                        :suffix="$store.getters.getSelectedCurrency"
                    />
                </v-col>
            </v-row>
        </template>
    </EditingDialog>
</template>

<script>
import EditingDialog from '@/components/_dialogs/EditingDialog'
import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'

export default {
    name: "PublishingContractsAdvanceEditPanelDialog",
    components: {
        EditingDialog,
        BaseEditPageTextField,
    },
    data() {
        return {
            context: 'PublishingContractsAdvance',
            alvqa: "contracts-publishing-edit-form-panel-advance-editing-dialog"
        }
    },
    methods: {
        formatDataBeforeSave(item) {
            item.amount = this.$alvPlugin.stringToFloat(item.amount)
            item.enteredBy = this.$store.getters.getUserUsername
            item.enteredOn = new Date()

            return item
        },
        afterSaving() {
            this.$store.dispatch('calculatePublishingContractsAdvanceBalance')
        }
    },
}
</script>
